import React from 'react';
// SEMANTIC
import { Card, Icon, Image } from 'semantic-ui-react';
// PROP-TYPES
import PropTypes from './PropTypes';
// STYLES
import styles from './style';

const Cards = ({
  image, step, title, text,
}) => {
  const classes = styles();

  return (
    <Card>
      <Image
        size="small"
        className={classes.imageCard}
        src={image}
        alt="Reparofone - Trocafone"
        wrapped
        ui={false}
      />
      <Card.Content>
        <Card.Header>{title}</Card.Header>
        <Card.Description>{text}</Card.Description>
      </Card.Content>
      <Card.Content extra>
        <Icon name="arrow circle right" />
        {step}
      </Card.Content>
    </Card>
  );
};

export default Cards;

Cards.propTypes = PropTypes.propTypes;
Cards.defaultProps = PropTypes.defaultProps;
